import { useState } from 'react';
import NavBar from './navBar';
import PageSelection from './pageSelection';
import Footer from './footer.js';
import { ContactForm } from './contactForm.js';

export default function App() {
  const [selection, setSelection] = useState("landing")

  return (
    <div
      style={{
        backgroundImage: `url("./timberPattern.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        height: "100%",
        overflow: "hidden",
      }}
    > 
      <NavBar setSelection={setSelection} />

      <PageSelection selection={selection} setSelection={setSelection} />

      <ContactForm setSelection={setSelection} />

      <Footer setSelection={setSelection} />

    </div>
  );
}
